import { cn, titleCase } from "@/lib/utils";
import { toneForStatus } from "@/lib/status";

export function Badge({ value, className }: { value: string; className?: string }) {
  return (
    <span className={cn(
      "semantic-badge gap-1.5",
      `semantic-badge--${toneForStatus(value)}`,
      className,
    )}>
      <span className="size-1.5 rounded-full bg-current" />{titleCase(value)}
    </span>
  );
}
